import styled from 'styled-components'

const orange = '#f15025'
const whitesmoke = 'whitesmoke'

// #85153e
const SimpleButton = styled.button`
background: #32a6bc;
color: white;
text-transform: uppercase;
border: none;
margin: 5px;
padding: 10px;
font-size: 16px;
font-weight: 100;
letter-spacing: 10px;
`

export default SimpleButton;